import { DeltaPill } from "./DeltaPill";

/**
 * Renders a single labelled statistic within the summary band.
 * @param label - The uppercase caption describing the metric.
 * @param value - The formatted metric value.
 * @param delta - The period-over-period change, or null.
 * @returns The stat column.
 */
export function Stat({
  label,
  value,
  delta,
}: {
  label: string;
  value: string;
  delta: number | null;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1.5 px-5 py-4">
      <span className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
        {label}
      </span>
      <span className="break-words text-xl font-semibold tabular-nums tracking-tight sm:text-2xl">
        {value}
      </span>
      <DeltaPill delta={delta} />
    </div>
  );
}
